module.exports = __webpack_public_path__ + "static/images/payments-with-shetab.png!static";